
    import './styles.scoped.css';
    export default {
  "help-panel": "awsui_help-panel_1d237_eunew_95",
  "header": "awsui_header_1d237_eunew_269",
  "content": "awsui_content_1d237_eunew_299",
  "footer": "awsui_footer_1d237_eunew_310"
};
  